<template>
	<div style="padding: 20px;flex: 1;" >
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						接入文档
					</div>
					<div style="padding: 10px;">
						<div class="tb">
							<div class="tb-body" v-for="(item,index) in url_list" :key="index">
								 <el-link type="primary" @click="openUrl(item)">{{item.title}}</el-link>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						帮助中心
					</div>
					<div style="padding: 10px;" v-loading="loading" >
						<div class="tb">
							<div class="tb-header">
								问题
							</div>
							<div class="tb-body" v-for="(item,index) in list" :key="index">
								 <el-link type="primary" @click="openInfo(item)">{{item.title}}</el-link>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			
			<el-col :span="12">
				
			</el-col>
		</el-row>
		<el-dialog title="信息" :visible.sync="dialogVisible" width="500px">
			<div style="border:1px solid #dedede;padding:10px 20px;font-size: 14px;color: #555;background-color: #f8f8f8;">
				{{info}}
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="small" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data(){
			return {
				list:[],
				dialogVisible:false,
				loading:false,
				info:'',
				url_list:[{
					title:'查看api文档',
					url:'https://www.showdoc.com.cn/controller/1511387152969339'
				},{
					title:'按键精灵PC版',
					url:'https://www.showdoc.com.cn/controller/7618879278952323'
				},{
					title:'按键精灵手机版',
					url:'https://www.showdoc.com.cn/controller/7618879278952323'
				},{
					title:'autojs',
					url:'https://www.showdoc.com.cn/controller/7618927067615056'
				},{
					title:'懒人精灵',
					url:'https://www.showdoc.com.cn/controller/8873505702131153'
				},{
					title:'视频教程',
					url:'https://www.showdoc.com.cn/controller/7618929356916216'
				}]
			}
		},
		created() {
			this.getList()
		},
		computed: {
			...mapState({
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.getList()
			}
		},
		methods:{
			getList(){
				this.loading = true
				this.$H.post('/quanlang/v1_0_1.Sys/HelpQuestionList',{}).then(res=>{
					this.loading = false
					if(res.data){
						this.list = res.data.list
					}
					
				})
			},
			openUrl(item){
				window.open(item.url)
			},
			openInfo(item){
				console.log(item)
				this.$H.post('/quanlang/v1_0_1.Sys/HelpQuestionAnswer',{id:item.id}).then(res=>{
					this.info = res.data.info
					this.dialogVisible = true
				})
				
			}
		}
	}
</script>
<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
	.t-item >>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
	.form>>>.el-input.is-disabled .el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-checkbox__label {
		color: #fff;
	}
	.tb{
		border: 1px solid #909090;
	}
	.tb-header {
		padding: 12px;
		font-size: 14px;
		font-weight: 700;
		display: flex;
	}

	.tb-body {
		padding: 12px;
		border-top: 1px solid #909090;
		font-size: 14px;
		font-weight: normal;
		display: flex;
	}
	.tb-body:hover {
		background-color: #909090;
	}
</style>